import type { User } from "@investhinks/api-client";
import React, { createContext, type ReactNode, useCallback, useContext, useState } from "react";

// ViewingUser is a User that is being viewed by an admin (for impersonation)
type ViewingUser = User;

interface AdminViewingUserContextValue {
  viewingUser: ViewingUser | null;
  setViewingUser: (user: ViewingUser | null) => void;
  clearViewingUser: () => void;
}

interface AdminViewingUserProviderProps {
  children: ReactNode;
}

const defaultContextValue: AdminViewingUserContextValue = {
  viewingUser: null,
  setViewingUser: () => {},
  clearViewingUser: () => {},
};

const AdminViewingUserContext = createContext<AdminViewingUserContextValue>(defaultContextValue);

export const AdminViewingUserProvider: React.FC<AdminViewingUserProviderProps> = ({ children }) => {
  const [viewingUser, setViewingUser] = useState<ViewingUser | null>(null);

  const clearViewingUser = useCallback(() => {
    setViewingUser(null);
  }, []);

  return (
    <AdminViewingUserContext.Provider value={{ viewingUser, setViewingUser, clearViewingUser }}>
      {children}
    </AdminViewingUserContext.Provider>
  );
};

export const useAdminViewingUser = () => useContext(AdminViewingUserContext);

export default AdminViewingUserContext;
